module.exports = __webpack_public_path__ + "static/img/photo-03-big.dee0ae6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-03-big.jpg
// module id = toIw
// module chunks = 1